import * as React from 'react';

// Hook
import { useTranslation } from '@shopee-user/platform';

export default function ResetPasswordLinkContent({
  listClassName,
}: {
  listClassName: string;
}) {
  const I18n = useTranslation();
  return (
    <>
      {I18n.t('msg_auth_to_continue')}
      <ol className={listClassName}>
        <li>{I18n.t('msg_auth_prompt_go_to_shopee')}</li>
        <li>{I18n.t('msg_auth_prompt_logout_if_logged_in')}</li>
        <li>{I18n.t('msg_auth_prompt_go_to_log_in')}</li>
        <li>{I18n.t('msg_auth_prompt_choose_forgot_password')}</li>
      </ol>
    </>
  );
}
